import {CacheItem} from "./CacheItem";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {concatMap, from, Observable, of, shareReplay, switchMap, tap} from "rxjs";
import {lastMap} from "../../rxjs/lastMap";
import {catchError, map} from "rxjs/operators";
import {retryWithBackoff} from "../../rxjs/retryWithBackoff";
import * as xml2js from 'xml2js'

export class CacheDBStudio {
  table;
  id;
  data: Observable<any>;

  constructor(table: string, id) {
    this.table = table;
    this.id = id;
  }

  getData(): Observable<any> {
    return this.data;
  }

  setData(data: Observable<any>) {
    this.data = data;
  }
}
